import { combineReducers } from 'redux'
import { createFullCycleHandlers } from 'utils/reducers'
import actions from 'actions/crm/postBlocker'
import state from './initial.state'

export default combineReducers({
  settings: createFullCycleHandlers(actions.settings, state.post_blocker.settings)
})
